module.exports = __webpack_public_path__ + "img/icon-54.bd0faf55.png";